<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog
            :title="'正在' + (isUpdate ? '更新' : '添加') + '赛事赞助'"
            :close-on-click-modal="false"
            @closed="reset"
            :visible.sync="visibleSync"
            width="70%">
        <el-form :model="sponsorshipInfo" ref="form" :rules="rules" label-width="80px">
            <el-form-item label="赞助方" prop="sponsor">
                <el-input v-model="sponsorshipInfo.sponsor" placeholder="请填写本校参赛队赞助商名称"></el-input>
            </el-form-item>
            <el-form-item label="赞助金额" prop="sponsorship_amount">
                <el-input class="full-width" placeholder="单位：万元" v-model="sponsorshipInfo.sponsorship_amount">
                    <template slot="append">万元</template>
                </el-input>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">保存</el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-button v-if="deletable" type="danger" style="float: right;" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        name: '',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
                if (!visible) return;
                const id = this.id;
                if (id === null || id === undefined) {
                    this.sponsorshipInfo = {};
                } else {
                    this.$store.dispatch('player/loadSponsorshipInfo', {
                        id
                    }).then(response => {
                        this.sponsorshipInfo = response.data;
                    });
                }
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            const checkNumber = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('赞助金额只能是数字'));
                }
                if (+value <= 0) {
                    callback(new Error('赞助金额必须大于 0（ 赞助非必填项，如无赞助可不填 ）'));
                }
                if (+value > 100000000) {
                    callback(new Error('赞助金额不能超过 1 亿元人民币'));
                }
            };
            return {
                visibleSync: null,
                sponsorshipInfo: {},
                requesting: false,
                deleteRequesting: false,
                rules: {
                    sponsor: [
                        {required: true, message: '赞助方名称不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '赞助方名称不能超过 30 个字', trigger: 'blur'}
                    ],
                    sponsorship_amount: [
                        {required: true, message: '赞助金额不能为空', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            }
        },
        methods: {
            remove () {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteSponsorship', {
                        id: this.id
                    }, '删除成功', true, this, 'deleteRequesting').then(_ => {
                        this.$emit('need-reload');
                        this.reset();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            confirm () {
                if (this.isUpdate) {
                    this.update();
                } else {
                    this.create();
                }
            },
            create () {
                this.handleTemplate('player/createSponsorship', '创建成功');
            },
            update () {
                this.handleTemplate('player/updateSponsorship', '更新成功');
            },
            handleTemplate (actionName, tip) {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const sponsorshipInfo = this.sponsorshipInfo;
                    sponsorshipInfo.sponsorship_amount = +sponsorshipInfo.sponsorship_amount;
                    this.$normalRequest(actionName, {
                        id: this.currentManagedPlayerId,
                        ...sponsorshipInfo
                    }, tip, true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.reset();
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.visibleSync = false;
                this.sponsorshipInfo = {};
            }
        }
    };
</script>
